import { useEffect, useRef } from 'react';
import { useNotify } from 'react-admin';

/**
 * Surface a data-load error once, as a warning toast, so an empty result isn't
 * silently mistaken for "nothing configured" (e.g. a failed `facets` fetch
 * would otherwise render as empty filter dropdowns with no explanation).
 * Re-notifies if the error clears and later recurs, so a failed retry is seen.
 */
export const useNotifyOnError = (error: unknown, message: string): void => {
  const notify = useNotify();
  const notified = useRef(false);

  useEffect(() => {
    if (error && !notified.current) {
      notified.current = true;
      notify(message, { type: 'warning' });
    } else if (!error) {
      notified.current = false;
    }
  }, [error, message, notify]);
};
